<template>
    <div>
        <portal-target :name="name"></portal-target>
    </div>
</template>

<script>
export default
{
    props:
    {
        name: {
            type: String,
            default: ''
        }
    }
}
</script>
